import axios from 'axios';
import { getEnvUrl } from '../../../../apps/virtual-brainary/src/onboarding/helpers/getEnvUrl';

export const getContentType = () => ({ 'Content-Type': 'application/json' });

const { apiBaseUrl } = getEnvUrl();

export const instance = axios.create({
    baseURL: apiBaseUrl,
    headers: getContentType(),
});

export default instance;